import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import "aos/dist/aos.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Services from "./components/pages/Services";
import Education from "./components/pages/Education";
import Work from "./components/pages/MyWork";
import ContactForm from "./components/pages/ContactForm";
import Loading from "./components/Loading";

function App() {
  const [loading, setLoading] = useState(true);

  //Handle loading and fetch data
  const getdata = () => {
    setLoading(true);
    try {
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    getdata();
  });
  if (loading) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/services" exact component={Services} />
          <Route path="/education" exact component={Education} />
          <Route path="/work" exact component={Work} />
          <Route path="/contact" exact component={ContactForm} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
